import getCharts from '../getCharts'
import { GetPatients } from '../../constants/api.config'

export default async function GetPatientsData(idnumber = "",mode="") {
  try {
    const payload = {idnumber,mode}
    const res = await getCharts(GetPatients, payload)
    return res.data
  } catch (error) {
    return error
  }
}
